import { UsersRound } from 'lucide-react';
import { RequireIgAccount } from '../../lib/igAccount';
import type { FeatureModule } from '../registry';
const buddies:FeatureModule={id:'buddies',nav:[{to:'/buddies',label:'Engagement Buddies',icon:UsersRound,group:'growth',order:25}],routes:[{
 path:'/buddies',lazy:async()=>{const {BuddiesPage}=await import('./BuddiesPage');return {Component:()=> <RequireIgAccount><BuddiesPage /></RequireIgAccount>};}
}]};
export default buddies;
